var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('app-header'),_c('router-view'),(_vm.$store.getters.contactForm)?_c('modal-contact-form'):_vm._e(),_c('transition',{attrs:{"name":"formResults"}},[(_vm.$store.getters.contactResult!==null)?_c('modal-form-result'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }